import * as Common from './common';
import * as Query from './query';
import * as Kardex from './kardex';
import * as Analysis from './analysis';
import * as ModalsActions from './modalsActions';
import * as codesWithoutLabels from './codesWithoutLabels';

const Actions = {
  ...Common,
  ...Query,
  ...Kardex,
  ...Analysis,
  ...ModalsActions,
  ...codesWithoutLabels,
};

export default Actions;
